import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'scDynamoRiskCleanup'
})
export class DynamoRiskCleanupPipe implements PipeTransform {

  charactersToReplace = ['|'];

  transform(value: string): string {
    this.charactersToReplace.forEach(element => {
      value = value.split(element).join(' ');
    });
    return value;
  }

}
